export default {
  title: 'Файлы',
  dropTitle: 'Перетащите файл сюда',
  select: 'или нажмите, чтобы выбрать',

  states: {
    error: 'Ошибка загрузки',
    success: 'Файл загружен',
    loading: 'Идёт загрузка файла'
  },

  drop: 'Перетащите файл сюда, чтобы загрузить'
}
